










import { Vue, Component } from "../vue-ext";

@Component
export default class StartView extends Vue {
    private async mounted() {
        console.log("startview mounted");
        setTimeout(async () => {
            try { 
                console.log("trying to authenticate");
                await this.root.authenticate();
            } catch {

            }
            
            if (this.root.isAuthenticated()) {
                this.$router.push("/choose-housing-company");
            } else {
                this.$router.push("/input-email");   
            }
         }, 1000);
    }
}
